import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/remove-circled.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-62e7647b")

_pushScopeId("data-v-62e7647b")
const _hoisted_1 = { class: "main-content-component" }
const _hoisted_2 = { class: "container neworder-customer-container" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "order-info" }
const _hoisted_5 = { class: "order-dates" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "dateDelimiter" }, "  ", -1)
const _hoisted_7 = { class: "order-customers-container" }
const _hoisted_8 = { class: "order-customers-container-title" }
const _hoisted_9 = { class: "order-customer-items" }
const _hoisted_10 = { class: "customer-type" }
const _hoisted_11 = { class: "customer-field-title" }
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "furry-point" }, "*", -1)
const _hoisted_13 = {
  key: 0,
  class: "customer-coupon-discount pl-6"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 2 }
const _hoisted_17 = {
  key: 0,
  class: "customer-coupon-left"
}
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "customer-row" }
const _hoisted_21 = {
  key: 0,
  style: {"gap":"10px"},
  class: "d-flex align-items-center"
}
const _hoisted_22 = {
  key: 0,
  class: "icon-f icon-coupon fs-14 cursor-initial"
}
const _hoisted_23 = /*#__PURE__*/_createVNode("span", { class: "icon-f path1 fs-16 cursor-initial" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("span", { class: "icon-f path2 fs-16 cursor-initial" }, null, -1)
const _hoisted_25 = { key: 1 }
const _hoisted_26 = {
  style: {"gap":"10px","justify-content":"space-between"},
  class: "d-flex align-items-center"
}
const _hoisted_27 = {
  key: 0,
  class: "icon-f icon-coupon fs-14 cursor-initial"
}
const _hoisted_28 = /*#__PURE__*/_createVNode("span", { class: "icon-f path1 fs-16 cursor-initial" }, null, -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("span", { class: "icon-f path2 fs-16 cursor-initial" }, null, -1)
const _hoisted_30 = /*#__PURE__*/_createVNode("div", { class: "separator" }, null, -1)
const _hoisted_31 = { class: "customer-qty" }
const _hoisted_32 = { class: "customer-field-title" }
const _hoisted_33 = /*#__PURE__*/_createVNode("div", { class: "separator" }, null, -1)
const _hoisted_34 = { class: "customer-field-title" }
const _hoisted_35 = { class: "customer-unit-price-value" }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = /*#__PURE__*/_createVNode("div", { class: "separator" }, null, -1)
const _hoisted_38 = { class: "customer-discount" }
const _hoisted_39 = { class: "customer-field-title" }
const _hoisted_40 = {
  key: 0,
  class: "customer-coupon-discount-value"
}
const _hoisted_41 = /*#__PURE__*/_createVNode("div", { class: "separator" }, null, -1)
const _hoisted_42 = { class: "customer-total-price" }
const _hoisted_43 = { class: "customer-field-title" }
const _hoisted_44 = {
  key: 0,
  class: "customer-total-price-value"
}
const _hoisted_45 = {
  key: 1,
  class: "customer-total-price-value"
}
const _hoisted_46 = /*#__PURE__*/_createVNode("div", null, "0", -1)
const _hoisted_47 = { class: "customer-remove" }
const _hoisted_48 = {
  key: 0,
  class: "add-customer-type-row"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_OrderHeader = _resolveComponent("OrderHeader")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_InputNumber = _resolveComponent("InputNumber")
  const _component_OrderProductPrice = _resolveComponent("OrderProductPrice")
  const _component_OrderMobileActionsFooter = _resolveComponent("OrderMobileActionsFooter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_OrderHeader, {
      formId: 'create-order-form',
      title: _ctx.isQuote ? _ctx.$t('label.create-quote') : _ctx.$t('addOrderProduct.addCustomerType'),
      backText: _ctx.$t('button.cancel'),
      submitText: _ctx.isQuote ? _ctx.$t('button.add-to-quote') : _ctx.$t('button.add-to-order'),
      formDisabled: !_ctx.calculated,
      onBack: _ctx.backToOrder
    }, null, 8, ["title", "backText", "submitText", "formDisabled", "onBack"]),
    _createVNode("div", _hoisted_2, [
      (_ctx.order)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("h1", null, _toDisplayString(_ctx.order.newproduct.productName), 1),
              _createVNode("div", _hoisted_5, [
                _createVNode("span", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.back()))
                }, [
                  _createVNode("span", null, _toDisplayString(_ctx.dateToTitle), 1),
                  _hoisted_6,
                  _createVNode("span", null, _toDisplayString(_ctx.order.newproduct.slot.startTimeView) + "-" + _toDisplayString(_ctx.order.newproduct.slot.endTimeView) + ", " + _toDisplayString(_ctx.getMinutes(_ctx.order.newproduct.slot.duration)) + " " + _toDisplayString(_ctx.$t('orders.min')), 1)
                ])
              ])
            ]),
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('addOrderProduct.addACustomersTypeAndQuantity')), 1),
              _createVNode("form", {
                onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.submitForm($event)), ["prevent"])),
                id: "create-order-form",
                novalidate: ""
              }, [
                _createVNode("div", _hoisted_9, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.order.newproduct.customers, (item, i) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "order-customer-item",
                      key: i
                    }, [
                      _createVNode("div", _hoisted_10, [
                        _createVNode("span", _hoisted_11, [
                          _createVNode("span", null, [
                            _createTextVNode(_toDisplayString(_ctx.$t('customerType.customerType')) + " ", 1),
                            _hoisted_12,
                            (item.customerInfo.couponId)
                              ? (_openBlock(), _createBlock("span", _hoisted_13, [
                                  (item.customerInfo.coupon.discountPercent)
                                    ? (_openBlock(), _createBlock("span", _hoisted_14, _toDisplayString(item.customerInfo.coupon.discountPercent) + "% ", 1))
                                    : (item.customerInfo.coupon.discountAmount)
                                      ? (_openBlock(), _createBlock("span", _hoisted_15, _toDisplayString(item.customerInfo.coupon.discountAmount) + " " + _toDisplayString(item.customerInfo.coupon.currencySymbol), 1))
                                      : (item.customerInfo.coupon.ticketFixedUnitPrice)
                                        ? (_openBlock(), _createBlock("span", _hoisted_16, _toDisplayString(item.customerInfo.coupon.ticketFixedUnitPrice) + " " + _toDisplayString(item.customerInfo.currencySymbol), 1))
                                        : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          (item.customerInfo.couponId)
                            ? (_openBlock(), _createBlock("span", _hoisted_17, [
                                (item.customerInfo.coupon.limitationType == _ctx.couponLimitationType.TotalAmount)
                                  ? (_openBlock(), _createBlock("span", _hoisted_18, _toDisplayString(_ctx.formatAmount(item.customerInfo.coupon.leftLimitationTotal)) + _toDisplayString(item.customerInfo.coupon.currencySymbol), 1))
                                  : (_openBlock(), _createBlock("span", _hoisted_19, _toDisplayString(item.customerInfo.coupon.leftLimitationTotal) + " " + _toDisplayString(_ctx.$t('label.tickets')), 1)),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('cashier.label.left')), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode("div", _hoisted_20, [
                          _createVNode(_component_Dropdown, {
                            required: "",
                            modelValue: item.customerInfo,
                            "onUpdate:modelValue": ($event: any) => (item.customerInfo = $event),
                            options: _ctx.availableTypes(item),
                            optionLabel: "name",
                            placeholder: "Select a Country",
                            class: "customer-ddl custom-multiselect-input",
                            onChange: ($event: any) => (_ctx.onChangeCustomerType($event, item)),
                            filter: !_ctx.isMobile,
                            filterBy: !_ctx.isMobile ? 'name' : null
                          }, {
                            value: _withId((slotProps) => [
                              (slotProps.value)
                                ? (_openBlock(), _createBlock("div", _hoisted_21, [
                                    (slotProps.value.couponId)
                                      ? (_openBlock(), _createBlock("span", _hoisted_22, [
                                          _hoisted_23,
                                          _hoisted_24
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createVNode("div", null, _toDisplayString(slotProps.value.name), 1)
                                  ]))
                                : (_openBlock(), _createBlock("span", _hoisted_25, _toDisplayString(slotProps.placeholder), 1))
                            ]),
                            option: _withId((slotProps) => [
                              _createVNode("div", _hoisted_26, [
                                _createVNode("div", null, _toDisplayString(slotProps.option.name), 1),
                                (slotProps.option.couponId)
                                  ? (_openBlock(), _createBlock("span", _hoisted_27, [
                                      _hoisted_28,
                                      _hoisted_29
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _: 2
                          }, 1032, ["modelValue", "onUpdate:modelValue", "options", "onChange", "filter", "filterBy"])
                        ])
                      ]),
                      _hoisted_30,
                      _createVNode("div", _hoisted_31, [
                        _createVNode("span", _hoisted_32, _toDisplayString(_ctx.$t('newOrder.QTY')), 1),
                        _createVNode("div", null, [
                          _withDirectives(_createVNode("input", {
                            required: "",
                            class: ["bookit-input order-input w100 text-c qty-input", {
                                                warning: item.limitExceeded || _ctx.isWarning(item),
                                                invalid: _ctx.wasValidated && !item.quantity
                                            }],
                            type: "number",
                            "onUpdate:modelValue": ($event: any) => (item.quantity = $event),
                            onInput: ($event: any) => {
                                                (item.limitExceeded = false),
                                                    (_ctx.calculated = false),
                                                    _ctx.debounce(() => {
                                                        _ctx.CalculateEventProductCustomers(item);
                                                    })
                                            },
                            onPaste: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.filterPastedOnlyNumber && _ctx.filterPastedOnlyNumber(...args))),
                            onKeypress: ($event: any) => (_ctx.filterKeyOnlyNumber($event), (item.limitExceeded = false)),
                            onChange: ($event: any) => (_ctx.filterKeyOnlyNumber($event), (item.limitExceeded = false))
                          }, null, 42, ["onUpdate:modelValue", "onInput", "onKeypress", "onChange"]), [
                            [_vModelText, item.quantity]
                          ])
                        ])
                      ]),
                      _hoisted_33,
                      _createVNode("div", {
                        class: ["customer-unit-price", { 'customer-unit-price-editable': _ctx.canChangeUnitPrice }]
                      }, [
                        _createVNode("span", _hoisted_34, _toDisplayString(_ctx.$t('newOrder.customerUnitPrice')), 1),
                        _createVNode("div", _hoisted_35, [
                          (_ctx.canChangeUnitPrice)
                            ? (_openBlock(), _createBlock(_component_InputNumber, {
                                key: 0,
                                required: "",
                                class: "priceForOne-input",
                                modelValue: item.priceForOne,
                                "onUpdate:modelValue": ($event: any) => (item.priceForOne = $event),
                                mode: 'decimal',
                                minFractionDigits: 2,
                                maxFractionDigits: 2,
                                min: 0,
                                allowEmpty: false,
                                suffix: ' ' + _ctx.getCustomerPriceCurrencySymbol(item.id),
                                onInput: ($event: any) => {
                                                _ctx.onInputPriceForOne($event, item),
                                                    _ctx.debounce(() => {
                                                        _ctx.CalculateEventProductCustomers(item);
                                                    })
                                            }
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "suffix", "onInput"]))
                            : (_openBlock(), _createBlock("span", _hoisted_36, _toDisplayString(_ctx.getCustomerPrice(item.id)) + _toDisplayString(_ctx.getCustomerPriceCurrencySymbol(item.id)), 1))
                        ])
                      ], 2),
                      _hoisted_37,
                      _createVNode("div", _hoisted_38, [
                        _createVNode("span", _hoisted_39, _toDisplayString(_ctx.$t('newOrder.discount')), 1),
                        (item.customerInfo.couponId)
                          ? (_openBlock(), _createBlock("div", _hoisted_40, _toDisplayString(_ctx.formatAmount(item.discountAmount)) + _toDisplayString(_ctx.order.newproduct.currencySign), 1))
                          : (_openBlock(), _createBlock(_component_InputNumber, {
                              key: 1,
                              class: "customer-discount-InputNumber",
                              disabled: 
                                            !item.customerInfo.id || !item.quantity || item.quantity == 0 || _ctx.getCustomerPrice(item.id) == 0
                                        ,
                              modelValue: item.discountAmount,
                              "onUpdate:modelValue": ($event: any) => (item.discountAmount = $event),
                              suffix: item.customerInfo.currencySymbol,
                              min: 0,
                              allowEmpty: false,
                              onInput: ($event: any) => {
                                            (_ctx.calculated = false),
                                                _ctx.setDiscount($event, item),
                                                _ctx.debounce(() => {
                                                    _ctx.CalculateEventProductCustomers(item);
                                                })
                                        }
                            }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "suffix", "onInput"]))
                      ]),
                      _hoisted_41,
                      _createVNode("div", _hoisted_42, [
                        _createVNode("span", _hoisted_43, _toDisplayString(_ctx.$t('priceList.price')), 1),
                        (_ctx.calculated)
                          ? (_openBlock(), _createBlock("div", _hoisted_44, _toDisplayString(_ctx.formatAmount(item.price)) + _toDisplayString(_ctx.order.newproduct.currencySign), 1))
                          : (_openBlock(), _createBlock("div", _hoisted_45, [
                              _hoisted_46
                            ]))
                      ]),
                      _createVNode("div", _hoisted_47, [
                        _createVNode("img", {
                          class: "",
                          src: _imports_0,
                          alt: "",
                          onClick: ($event: any) => (_ctx.deleteRow(i))
                        }, null, 8, ["onClick"])
                      ])
                    ]))
                  }), 128))
                ])
              ], 32),
              (_ctx.showAddCustomType)
                ? (_openBlock(), _createBlock("div", _hoisted_48, [
                    _createVNode("button", {
                      type: "button",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addCustomerType()))
                    }, _toDisplayString(_ctx.$t('customerType.addCustomerType')), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_OrderProductPrice, {
              priceTotalWithOutDiscount: _ctx.order.newproduct.priceTotalWithOutDiscount,
              discountTotal: _ctx.order.newproduct.discountTotal,
              price: _ctx.order.newproduct.price,
              currencySign: _ctx.order.newproduct.currencySign,
              customerTotalToPay: _ctx.order.newproduct.customerTotalToPay,
              businessClientTotalToPay: _ctx.order.newproduct.businessClientTotalToPay
            }, null, 8, ["priceTotalWithOutDiscount", "discountTotal", "price", "currencySign", "customerTotalToPay", "businessClientTotalToPay"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_OrderMobileActionsFooter, {
      "from-id": 'create-order-form',
      calculated: _ctx.calculated,
      onBackEmit: _cache[5] || (_cache[5] = ($event: any) => (_ctx.back()))
    }, null, 8, ["calculated"])
  ]))
})